import app from '../app.first';
import $ from 'jquery';

app.RecruiterInterview = class extends app.Component {
	onReady() {

		$('input[type="radio"]:checked').each(function() { 
			let radioButton = $(this); 
			let radioValue = radioButton.val();
			for (let radioLoop = 1; radioLoop <= radioValue; radioLoop++) {
				radioButton.parent().parent().children('label:nth-child(' + (radioLoop + 1).toString() + ')').addClass('checked');
			}
		});

		$('input[type="radio"]').click(function() { 
			let radioButton = $(this); 
			radioButton.parent().parent().children('label').each(function() { 
				$(this).removeClass('checked')
			});
			let radioValue = radioButton.val();
			for (let radioLoop = 1; radioLoop <= radioValue; radioLoop++) {
				radioButton.parent().parent().children('label:nth-child(' + (radioLoop + 1).toString() + ')').addClass('checked');
			}
		});
		
		$("select").select2({minimumResultsForSearch: -1});//prevent select2 from displaying search dropdown
		
        this.$el.on('change', '.interviewee-select', async e => {
            let $parentRow = $(e.target).parents('tr');
            let intervieweeId = $(e.target).val();

            let result = await app.ajax(
                `/recruiter/interviews/select-interviewee/${intervieweeId}.json`,
                { selected: e.target.checked },
                false
			);

            if (result && result.selected) {
                $parentRow.addClass('is-selected');
            } else {
                e.target.checked = false;
                $parentRow.removeClass('is-selected');
            }

			$(document).trigger('Recruiter.Interviewees.selectedIds.change');
		});

		$('.select-all').on('click',() => {
			this.selectAll();
		})

		$('.select-none').on('click',() => {
			this.selectNone();
		})

		this.$el.find('.selected-list').on(
			'click',
			'.remove',
			e => this.removeSelected($(e.target).closest('[data-user-detail-id]').data('userDetailId'))
		);
	}
}